<template>
  <div>
    <m-header
      :title-text="$t('masterData.jurisdictions')"
    />
    <l-rows>
      <l-rows>
        <l-rows-row content-position="right">
          <a-button
            :text="$t('masterData.addJurisdiction')"
            variant="primary"
            @click="handleCreate"
          />
        </l-rows-row>
      </l-rows>
      <o-list
        :data="jurisdictionPage.jurisdictions"
        :columns="columns"
        :loading="jurisdictionPageMeta.loading"
        :limit="jurisdictionPageInput.limit"
        :offset="jurisdictionPageInput.offset"
        :total="jurisdictionPage.totalCount"
        selectable
        @select="handleSelect"
      />
    </l-rows>
  </div>
</template>

<script>
  import { AButton, LRows, LRowsRow, MHeader, OList } from 'codefabrik-gui-vue'
  import { useJurisdictionPage } from '@/views/casinos/casinoHooks'

  export default {
    name: 'JurisdictionList',
    components: { LRows, LRowsRow, MHeader, OList, AButton },
    computed: {
      columns () {
        return [
          {
            field: 'key',
            header: this.$t('common.key'),
            size: 4
          },
          {
            field: 'description',
            header: this.$t('common.description'),
          }
        ]
      }
    },
    methods: {
      handleCreate () {
        this.$router.push({ name: 'casino-jurisdiction-create' })
      },
      handleSelect (item) {
        this.$router.push({ name: 'casino-jurisdiction', params: { jurisdictionId: item.id } })
      }
    },
    mixins: [useJurisdictionPage()]
  }
</script>

<style scoped>

</style>
